<nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
        <a (click)="changeSidebarStatus()" class="menu-icon-btn" id="sidebarCollapse">
            <i class="fa fa-bars" aria-hidden="true"></i>
        </a>
        <div class="logo-text-con">
            <a href="javascript:void(0)" class="logo-text"><img src="assets/logo.png"> </a>
        </div>
        <div class="logo-text-con" style="height: 52px; width: 152px;">
            <a href="javascript:void(0)" class="logo-text"><img style="width: 170px;
            " src="assets/customer_2.png"> </a>
        </div>

        <div class="collapse navbar-collapse header-menu" id="navbarSupportedContent">
            <ul class="nav navbar-nav top-menu w-100">
                <!-- <li class="active w-100 text-right">
                    <a href="index.html">Overview</a>
                </li> -->
                <li [ngClass]="{'active' : menu.isActive}"  *ngFor="let menu of menuArray">
                    <a [routerLink]="[menu.url]">{{menu.name}}</a>
                </li>
            </ul>
        </div>
        <div class="menu-icon-ul-con ml-auto">
            <ul class="menu-icon-ul header-filter-bar">
                <!-- <li>
                    <a href="javascript:void(0)" id="searchIcon"><img src="assets/images/searchIcon.svg" /></a>
                    <div class="search-box-con">
                        <form>
                            <span class="search-box-icon">
                                <input type="text" class="searchInput " name="search" placeholder="Search..">
                            </span>
                        </form>
                    </div>

                </li> -->
                <!-- <li>
                    <mat-slide-toggle [formControl]="darkThemeEnabledCtrl">
                        Dark-Mode
                    </mat-slide-toggle>
                </li>
                <li>
                    <mat-label>Select a Theme Color</mat-label>
                    <mat-select [(ngModel)]="selectedTheme" name="selectedTheme" (selectionChange)="changeThemeColor($event)"
                        class="mat-input-element" placeholder="Select Theme Color">
                        <mat-option *ngFor="let theme of themeColorEnum | keyvalue" [value]="theme.value" >
                          {{theme.key}}
                        </mat-option>
                    </mat-select>
                </li> -->
                
                <li class="dropdown noti-box-con mt-1" class="white-color-content">

                    <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon matBadge="15">notifications</mat-icon>
                      </button> -->
                      <mat-menu #menu="matMenu">
                        <!-- <button mat-menu-item disabled>
                          <mat-icon>voicemail</mat-icon>
                          <span>Check voice mail</span>
                        </button>
                        <button mat-menu-item>
                          <mat-icon>notifications_off</mat-icon>
                          <span>Disable alerts</span>
                        </button> -->
                      </mat-menu>
                      


                    <!-- <a class="notifications-text" href="javascript:void(0)" id="notificationsDropdown"
                        data-toggle="dropdown">
                        <img src="assets/images/notificationsIcon.svg" />
                        <span class="noti-count">03</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="notificationsDropdown">
                        <a href="javascript:void(0)" (click)="openChangePasswordModal()"> Change Password</a>
                        <a href="javascript:void(0)"> notifications 2</a>
                        <a href="javascript:void(0)"> notifications 3</a>
                    </div> -->
                </li>
                
                <!-- <li>
                    <a href="javascript:void(0)"><img src="assets/images/menuIcon.svg" /></a>
                </li> -->
            </ul>
        </div>
        <button class="menu-toggle-icon  d-inline-block d-lg-none" type="button" data-toggle="collapse"
            data-target="#navbarSupportedContent">
            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
        </button>

    </div>
</nav>
<ng-container #changePasswordContainer></ng-container>